<template>
	<div>
		<userInfo :row="row" v-if="column.isDaren" />
		<div v-if="column.isHead" class="flex-row-align-center">
			<div class="placeholderInstitution color-gy-9 fz-14 yx-pingfang-Medium">
				{{ placeholder }}
			</div>
			<p class="color-gy-9 fz-14 yx-pingfang-Medium ml-8 flex-row flex-align-center flex-1">
				<platform-icon :platformId="row.platform_id"></platform-icon>
				<span class="line-ellipsis-1 flex-1 ml-4">{{ row.institution_name }}</span>
			</p>
		</div>
		<div v-if="column.isProduct" class="flex-row-align-center">
			<el-image style="width: 64px; height: 64px; border-radius: 4px" class="mr-8" :src="row.product_pic">
				<template v-slot:error>
					<img src="@/assets/public/img-empty1.png" alt="" />
				</template>
			</el-image>
			<div class="ml-8 flex-1">
				<p class="color-gy-9 fz-14 yx-pingfang-Medium flex-row flex-align-center flex-1">
					<platform-icon :platformId="row.platform_id"></platform-icon>
					<span class="line-ellipsis-1 flex-1 ml-4">{{ row.product_name }}</span>
				</p>
				<p class="color-gy-7 fz-12 flex-row">
					商品ID：
					<span class="line-ellipsis-1 flex-1">{{ row.third_product_id }} </span>
					<i @click="$copy(row.third_product_id)" class="el-icon-copy-document cursor-pointer ml-4 mt-2 hover"></i>
				</p>
			</div>
		</div>
	</div>
</template>

<script>
import mixin from '@/components/tableCells/mixin.js';
import userInfo from '../userInfo';
export default {
	mixins: [mixin],
	components: {
		userInfo,
	},
	computed: {
		placeholder() {
			return this.row.institution_name?.charAt();
		},
	},
};
</script>

<style lang="less">
.placeholderInstitution {
	background: @color-b2;
	border-radius: 100px;
	width: 32px;
	height: 32px;
	display: flex;
	align-items: center;
	justify-content: center;
}
</style>